/** Domain service module: finance.js */
import { request, requestOutside } from '../http/request'
import { API_BASE_URL } from './config'

class BankService {
  list() {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await requestOutside(`https://brasilapi.com.br/api/banks/v1`, 'get')
        resolve(_result?.data || [])
      } catch (error) {
        reject(error)
      }
    });
  }
}

class CashFlowCategoryService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/cashFlowCategory/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashFlowCategory/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  listLastLevel(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashFlowCategory/listLastLevel?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  get(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/cashFlowCategory/get`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class CashierService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashier/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  deposit(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashier/deposit`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashier/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashier/delete/${id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  balanceSinceLastClosing(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashier/balanceSinceLastClosing`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class CashierTransferService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashierTransfer/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  create(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashierTransfer/create`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class CashierMovementService {
  list(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/cashierMovement/list`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class InvoiceService {
  listAdmin(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/listAdmin?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  myInvoices(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/myInvoices?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  myPendingInvoices(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/myPendingInvoices`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  create(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/create`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  writeOff(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/writeOff`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  analytical(filters) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/invoice/analytical`, 'post', filters)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class BillingAgreementService {
  create(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/billingAgreement/create`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class PaymentMethodService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/paymentMethod/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/paymentMethod/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/paymentMethod/delete/${id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class GroupPaymentService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/groupPayments/list?page=${page || 1}`, 'POST', data);

        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  completePayment(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/groupPayments/complete`, 'POST', data);

        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  recreatePayment(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/groupPayments/recreate`, 'POST', data);

        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/groupPayments/update`, 'POST', data);

        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }
}

class ReceiptService {
  viewReceipt(id) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/receipt/view/${id}`, 'get');

        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }
}

export const bank = new BankService()
export const cashFlowCategory = new CashFlowCategoryService()
export const cashier = new CashierService()
export const cashierTransfer = new CashierTransferService()
export const cashierMovement = new CashierMovementService()
export const invoice = new InvoiceService()
export const billingAgreement = new BillingAgreementService()
export const paymentMethod = new PaymentMethodService()
export const groupPayment = new GroupPaymentService()
export const receipt = new ReceiptService()
